$(function () {
	$('input.scroll_btn_').click(function () {
			var speed = 500;
			$("html, body").animate({ scrollTop: 450 }, speed, "swing");
			return false;
	});
});

// お礼状作成 ステップ3スキップ
isSubmitted = false;
$('[name="skip_link"]').on('click', function () {
	if (isSubmitted) {
		return false;
	};
	var form = $('[name="create-thanks"]');
	isSubmitted = true;
	form.submit();
});
$('#sort>li').on('click', function () {
	$('input[name="s"]').val($(this).data('val'));
	$('#search-form').submit();
});
// テンプレート検索　絞り込み解除
$('#condition_reset').click(function () {
	$('.sort').children().removeClass('active');
	$('input[name="s"]').remove();
	$('.detail input:checkbox').prop('checked', false);
	$('#search-form').submit();
});
// お礼状作成 お気に入り追加・解除
$('.create_favorite_toggle').on('click', function () {
	doCreateFavorites($(this), '/images/client/common/', 'icon_heart.svg', 'icon_heart_line_gray.svg');
});
$('.create_preview_favorite_toggle').on('click', function () {
	doCreateFavorites($(this), '/images/client/common/', 'icon_heart.svg', 'icon_heart_line_pink.svg');
});
// お礼状編集 詳細お気に入り追加・解除
$('#create_detail_favorite_sp').on('click', function () {
	console.log('#create_detail_favorite_sp:click');
	doCreateFavorites2($(this), '/images/client/template/', 'icon_favorite_on_re.svg', 'icon_favorite_off_re2.svg', $('#create_detail_favorite_pc'), 'icon_favorite_on.svg', 'icon_favorite_off.svg');
});
$('#create_detail_favorite_pc').on('click', function () {
	console.log('#carea_detail_favorite_pc:click');
	doCreateFavorites2($(this), '/images/client/template/', 'icon_favorite_on.svg', 'icon_favorite_off.svg', $('#create_detail_favorite_sp'), 'icon_favorite_on_re.svg', 'icon_favorite_off_re2.svg');
});
function doCreateFavorites(targetBtn, imgPath, onImg, offImg) {
	$.ajax({
		url: '/api/u/thanks/create/favorites',
        type: 'post',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
		dataType: 'json',
		data: { thanks_base_template_id: targetBtn.data('value') },
		success: function success($response) {
			favImg = targetBtn.find('img');
			var src = favImg.attr('src').endsWith(onImg) ? offImg : onImg;
			favImg.attr('src', imgPath + src);
			showHeaderBandMessage($response['message']);
		},
		error: function error($response) {
			console.log('failed');
		}
	});
}
function doCreateFavorites2(targetBtn, imgPath, onImg, offImg, targetBtn2, onImg2, offImg2) {
	$.ajax({
		url: '/api/u/thanks/create/favorites',
        type: 'post',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
		dataType: 'json',
		data: { thanks_base_template_id: $('#create_detail_favorite').data('value') },
		success: function success(response) {
			favImg = targetBtn;
			console.dir(response);
			console.dir(favImg);
			console.dir(onImg);
			console.dir(offImg);
			var src = favImg.attr('src').endsWith(onImg) ? offImg : onImg;
			favImg.attr('src', imgPath + src);
			if (targetBtn2 != null) {
				favImg2 = targetBtn2;
				var src2 = favImg2.attr('src').endsWith(onImg2) ? offImg2 : onImg2;
				console.log(src2);
				favImg2.attr('src', imgPath + src2);
			}
			showHeaderBandMessage(response['message']);
		},
		error: function error(response) {
			console.dir(response);
			console.log('doCreateFavorites:failed');
		}
	});
}
// お礼状編集 お気に入り追加・解除
$('.edit_favorite_toggle').on('click', function () {
	doEditFavorites($(this), '/images/client/common/', 'icon_heart.svg', 'icon_heart_line_gray.svg');
});
$('.edit_preview_favorite_toggle').on('click', function () {
	doEditFavorites($(this), '/images/client/common/', 'icon_heart.svg', 'icon_heart_line_pink.svg');
});
// お礼状編集 詳細お気に入り追加・解除
$('#edit_detail_favorite_sp').on('click', function () {
	// console.log('#edit_detail_favorite_sp:click');
	doEditFavorites($(this), '/images/client/template/', 'icon_favorite_on_re.svg', 'icon_favorite_off_re.svg', $('#edit_detail_favorite_pc'), 'icon_favorite_on.svg', 'icon_favorite_off.svg');
});
$('#edit_detail_favorite_pc').on('click', function () {
	// console.log('#edit_detail_favorite_pc:click');
	doEditFavorites($(this), '/images/client/template/', 'icon_favorite_on.svg', 'icon_favorite_off.svg', $('#edit_detail_favorite_sp'), 'icon_favorite_on_re.svg', 'icon_favorite_off_re.svg');
});
function doEditFavorites(targetBtn, imgPath, onImg, offImg, targetBtn2, onImg2, offImg2) {
	$.ajax({
		url: '/api/u/thanks/' + targetBtn.data('thanks') + '/edit/favorites',
        type: 'post',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
		dataType: 'json',
		data: {
			thanks_base_template_id: targetBtn.data('value')
		},
		success: function success(response) {
			//			console.log('success');
			//			console.dir(response);
			favImg = targetBtn.find('img');
			var src = favImg.attr('src').endsWith(onImg) ? offImg : onImg;
			//			console.log(src);
			favImg.attr('src', imgPath + src);
			if (targetBtn2 != null) {
				favImg2 = targetBtn2.find('img');
				var src2 = favImg2.attr('src').endsWith(onImg2) ? offImg2 : onImg2;
				//				console.log(src2);
				favImg2.attr('src', imgPath + src2);
			}
			showHeaderBandMessage(response['message']);
		},
		error: function error(response) {
			console.dir(response);
			console.log('doEditFavorites:failed');
		}
	});
}
// プレミアムLPへの遷移用
$('.purchase-lp').on('click', function () {
	var form = $('[name="premium-form"]');
	form.submit();
});
$(document).ready(function () {
	$('.sort_ .selection_').click(function () {
			$('.sort_ .detail_').toggleClass('detail_show_');
	});
	$('.refine_ .selection_').click(function () {
			$('.refine_ .detail_').toggleClass('detail_show_');
	});
});
// お礼状編集 挨拶文、フォーム文テンプレート
$('.ul_message_sample>li .radio-icon').click(function () {
	console.log('click');
	//	$('.ul_message_sample>li').removeClass('active');
	//	$(this).addClass('active');
	var template_id = $(this).data('template-id');
	console.log(template_id);
	$('input[name="template_id"]').val(template_id);
	$('input[name="dummy_template_id"][value=' + template_id + ']').prop('checked', true);
	$('#form_btn').addClass('btn_active').prop("disabled", false);
});
// $('form[name="message-form"] textarea').on('change keyup paste', function () {
//     if ($(this).val() != $('input[name="original_message"]').val()) {
//         $('#form_btn').addClass('btn_active').prop("disabled", false);
//     } else {
//         $('#form_btn').removeClass('btn_active').prop("disabled", true);
//     }
// });
// プロフィール編集
// $('form[name="profile-form"] input:text, form[name="profile-form"] textarea').on('change keyup paste', function () {
//     var hasChanged = false;
//     if ($("input[name=groom_last_name]").val() != $("input[name=original_groom_last_name]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=groom_last_name_kana]").val() != $("input[name=original_groom_last_name_kana]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=groom_first_name]").val() != $("input[name=original_groom_first_name]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=groom_first_name_kana]").val() != $("input[name=original_groom_first_name_kana]").val()) {
//         hasChanged = true;
//     } else if ($("textarea[name=groom_introduction]").val() != $("input[name=original_groom_introduction]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=bride_last_name]").val() != $("input[name=original_bride_last_name]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=bride_last_name_kana]").val() != $("input[name=original_bride_last_name_kana]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=bride_first_name]").val() != $("input[name=original_bride_first_name]").val()) {
//         hasChanged = true;
//     } else if ($("input[name=bride_first_name_kana]").val() != $("input[name=original_bride_first_name_kana]").val()) {
//         hasChanged = true;
//     } else if ($("textarea[name=bride_introduction]").val() != $("input[name=original_bride_introduction]").val()) {
//         hasChanged = true;
//     }
//     if (hasChanged) {
//         $('#form_btn').addClass('btn_active').prop("disabled", false);
//     } else {
//         $('#form_btn').removeClass('btn_active').prop("disabled", true);
//     }
// });
// TIPS
$('#tips_btn').on('click', function () {
	$('#tips').addClass('modal-window-active');
});
$('#tips_close_btn').on('click', function () {
	$('#tips').removeClass('modal-window-active');
});
// モーダル系
$('.modal-inner').on('click', function () {
	removeModalActive();
});
$('.modal_base_inner').on('click', function (e) {
	e.stopPropagation();
});
$('.close_modal').on('click', function (e) {
	removeModalActive();
});
window.removeModalActive = function () {
	if ($('.modal-window').hasClass('modal-window-active')) {
		$('.modal-window').removeClass('modal-window-active');
	}
};

$(function() {
	var h = $(window).height();
	var w = $(window).width();
	$('#loader-bg_ ,#loading_').width(w).height(h).css('display','block');
});
$(window).on('load', function () { //全ての読み込みが完了したら実行
	stoploading_()
});
function stoploading_() {
	$('#loader-bg_').delay(2000).fadeOut(800);
	$('#loading_').delay(1800).fadeOut(300);
	setTimeout(function() {
			$("#login_").trigger('unlockLogin', arguments);
	}, 2000);
};